import { useState } from "react";
import {
  Body,
  BottomSheet,
  BottomSheetHead,
  BottomSheetListWrapper,
  Button,
  ChevronIcon,
  Drawer,
  Input,
  ListItem,
  TextArea,
} from "@songtradr-one/components-frontend";
import { Flex } from "@songtradr-one/shared-frontend";
import {
  ButtonContainer,
  INQUIRY_OPTIONS,
  Props,
  StudioSupportLogo,
  text,
  useCustomerSupport,
} from "./CustomerSupport.Parts";

export const CustomerSupportMobile = ({ onOpenChange }: Props) => {
  const {
    isOpen,
    inquiry,
    setInquiry,
    category,
    setCategory,
    loading,
    handleOpenChange,
    handleSubmit,
  } = useCustomerSupport({ onOpenChange });

  const [categorySheetOpen, setCategorySheetOpen] = useState(false);

  return (
    <Drawer
      open={isOpen}
      onOpenChange={handleOpenChange}
      title={text.title}
      origin="bottom"
    >
      <Flex $direction="column" $gap="1.5rem">
        <Flex $align="center" $wrap="nowrap">
          <StudioSupportLogo src="https://assets.studio.massivemusic.com/statics/studio-support-header-logo" />
          <Flex $direction="column" $gap="0rem">
            <Body variant="normal-strong">{text.descriptionOne}</Body>
            <Body>{text.descriptionTwo}</Body>
          </Flex>
        </Flex>
        <Flex $direction="column" $gap="0.5rem">
          <Input
            label={text.selectLabel}
            placeholder={text.selectPlaceholder}
            value={category}
            readOnly
            onClick={() => setCategorySheetOpen(true)}
            customActions={[
              {
                icon: <ChevronIcon orientation="down" />,
                onClick: () => setCategorySheetOpen(true),
              },
            ]}
          />
        </Flex>
        <BottomSheet
          draggable
          open={categorySheetOpen}
          onOpenChange={setCategorySheetOpen}
          hiddenTitle={text.selectLabel}
        >
          <BottomSheetHead title={text.selectLabel} />
          <BottomSheetListWrapper>
            {INQUIRY_OPTIONS.map((option) => (
              <ListItem
                key={option.value}
                label={option.label}
                selected={category === option.value}
                onClick={() => {
                  setCategory(option.value);
                  setCategorySheetOpen(false);
                }}
              />
            ))}
          </BottomSheetListWrapper>
        </BottomSheet>
        <TextArea
          ref={(el) => {
            if (el && isOpen) setTimeout(() => el.focus(), 0);
          }}
          width="100%"
          label={text.textAreaLabel}
          value={inquiry}
          onChange={(e) => setInquiry(e.target.value)}
        />
        <ButtonContainer>
          <Button
            $variant="primary"
            disabled={!inquiry.length || !category}
            onClick={handleSubmit}
            loading={loading}
          >
            {text.submitButton}
          </Button>
        </ButtonContainer>
      </Flex>
    </Drawer>
  );
};
